export default {
  message: {
    hello: 'Hello World',
    basicInfo: 'Basic Information',
    aboutUs: 'About Us',
    downloadLink: 'Download Link',
    refer: 'Please Refer To',
    documentLink: 'Documentation Link',
    contactDetails: 'Contact Details',
    contactEmail: 'Email: <a href="mailto:contact@rustsbi.com">contact@rustsbi.com</a>',
    contactAddress: 'Address: Laboratory B513, Mingde Building, National Cybersecurity Center, Dongxihu District, Wuhan, Hubei Province',
    whatIsTitle: 'What is RustSBI',
    whatIsContent: 'RustSBI is a complete secure bootloader implementation designed to implement the RISC-V SBI interface for firmware, virtualization software, and simulators.',
    whatCanDoTitle: 'What Can RustSBI Do',
    whatCanDoTitle1: 'Firmware',
    whatCanDoTitle2: 'Virtualization',
    whatCanDoTitle3: 'Security',
    whatCanDoContent1: 'RustSBI is a complete secure bootloader implementation designed to implement the RISC-V SBI interface for firmware, virtualization software, and simulators.',
    whatCanDoContent2: 'RustSBI supports virtualization-related features and can serve as a foundational platform for virtualization software. It provides an extensible virtualization framework, helping developers achieve efficient virtualization on the RISC-V architecture.',
    whatCanDoContent3: 'Due to its high security and performance characteristics, RustSBI is suitable for aerospace, IoT, and high-security domains.',
    theyAreUsingTitle: 'They Are Using RustSBI',
    historyTitle: 'The History of RustSBI',
    historyContent1: 'The RustSBI project was incubated in 2020 during the Summer of Code event co-hosted by the rCore team and Pengcheng Laboratory, evolving from the MeowSBI project.',
    historyContent2: 'To date, RustSBI has undergone years of development and is widely used in bare-metal firmware, virtualization software, and simulators.',
    teamTitle: 'Team Members',
  },
};
